import { Button, Icon } from '@lomadee/design-system';
import { ComponentProps } from 'react';
import styled from 'styled-components';

export const TeammateWrapper = styled.div<ComponentProps<'div'>>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  padding: 16px 20px;

  background: #ffffff;

  border: 1px solid ${({ theme }): string => theme.colors.neutralHighMedium};
  box-sizing: border-box;
  border-radius: 8px;

  span {
    flex: 1;
  }
`;

export const RemoveTeammateIcon = styled(Icon)`
  cursor: pointer;
`;

export const StyledButton = styled(Button)`
  margin-top: auto;
`;
